import React from 'react'
import styled from 'styled-components'
import { EcoFarmConfig } from 'config/constants/ecoBoost'
import EcoBoostInfo from '../FarmTable/Actions/EcoBoostInfo'
import NFTBoostAction from '../FarmTable/Actions/NFTBoostAction'

export interface EcoBoostPanelProps {
  farmId: number
  ecoFarm: EcoFarmConfig
}

const Container = styled.div`
  overflow: hidden;
  background: #041851;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
`

const EcoBoostPanel: React.FunctionComponent<EcoBoostPanelProps> = ({ farmId, ecoFarm }) => {
  return (
    <Container>
      <EcoBoostInfo ecoFarm={ecoFarm} farmId={farmId} />
      <NFTBoostAction farmId={farmId} disabled={false} iconWidth={ecoFarm.iconWidth} icon={ecoFarm.icon} />
    </Container>
  )
}

export default EcoBoostPanel
